// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__SmNkI","footer":"ModalFilter_footer__mDcc4"};